import { Stack, Typography } from '@mui/material';
import { FC } from 'react';

interface TransactionsDetailsItemProps {
	title: string;
	value: string;
}

export const TransactionsDetailsItem: FC<TransactionsDetailsItemProps> = ({ title, value }) => {
	return (
		<Stack>
			<Typography variant={'caption'}>{title}</Typography>
			<Typography variant={'body1'}>{value}</Typography>
		</Stack>
	);
};
